import React from 'react';
import {Box, Divider, Drawer, Typography, useMediaQuery} from '@mui/material';
import {NavItem} from './nav-item';
import {Link} from "react-router-dom";
import {Logo} from "./logo";

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HomeIcon from '@mui/icons-material/Home';
import PeopleIcon from '@mui/icons-material/People';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';

const SideMenuItems = [
    {
        href: '/',
        icon: (<HomeIcon  />),
        title: 'Home'
    },
    {
        href: '/court-approvals',
        icon: (<CheckCircleIcon />),
        title: 'Court Approvals'
    },
    {
        href: '/court-corrections',
        icon: (<HomeRepairServiceIcon />),
        title: 'Court Corrections'
    },
    {
        href: '/users',
        icon: (<PeopleIcon />),
        title: 'Users'
    },
    {
        href: '/app-store',
        icon: (<HomeIcon />),
        title: 'Download Test'
    },
    // {
    //     href: '/sub-item1',
    //     icon: (<EditIcon />),
    //     title: 'Item 2',
    //     indent: 1,
    // },
];


export const DashboardSidebar = (props) => {
    const {open, onClose} = props;
    const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'), {
        defaultMatches: true,
        noSsr: false
    });

    const content = (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%'
                }}
            >
                <div>
                    <Box sx={{px: 3, pt: 3}}>
                        <Link to="/">
                            <Logo/>
                        </Link>
                    </Box>
                </div>
                <Divider
                    sx={{
                        borderColor: '#2D3748',
                        mb: 3
                    }}
                />

                {/*<Box*/}
                {/*    sx={{*/}
                {/*        px: 3,*/}
                {/*        pb: 1*/}
                {/*    }}*/}

                {/*>*/}
                {/*    <Typography*/}
                {/*        color="neutral.100"*/}
                {/*        variant="subtitle1"*/}
                {/*    >*/}
                {/*        Home*/}
                {/*    </Typography>*/}
                {/*</Box>*/}

                <Box sx={{flexGrow: 1}}>

                    {SideMenuItems.map((item) => (
                        <NavItem
                            key={item.title}
                            icon={item.icon}
                            href={item.href}
                            title={item.title}
                            indent={item.indent}
                        />
                    ))}
                </Box>
                <Divider sx={{borderColor: '#2D3748'}}/>
            </Box>
        </>
    );

    if (lgUp) {
        return (
            <Drawer
                anchor="left"
                open
                PaperProps={{
                    sx: {
                        backgroundColor: 'neutral.900',
                        color: '#FFFFFF',
                        width: 280
                    }
                }}
                variant="permanent"
            >
                {content}
            </Drawer>
        );
    }

    return (
        <Drawer
            anchor="left"
            onClose={onClose}
            open={open}
            PaperProps={{
                sx: {
                    backgroundColor: 'neutral.900',
                    color: '#FFFFFF',
                    width: 280
                }
            }}
            sx={{zIndex: (theme) => theme.zIndex.appBar + 100}}
            variant="temporary"
        >
            {content}
        </Drawer>
    );
};
